module.exports = __webpack_public_path__ + "img/scene1-3.f88edf7f.png";